﻿import {RemoteData, useRemoteData} from "@2d-front-monorepo/design-library";
import {InstallationByHostData, ParkingType, PermitParkingTypeData, ReservationCategoryData} from "@2d-front-monorepo/permits-business";
import {getHttpClient} from "./getHttpClient";

export function loadPermitParkingTypeData(parkingType: ParkingType): RemoteData<PermitParkingTypeData>;
export function loadPermitParkingTypeData(parkingType: undefined): RemoteData<undefined>;
export function loadPermitParkingTypeData(parkingType: ParkingType | undefined): RemoteData<PermitParkingTypeData | undefined>;
export function loadPermitParkingTypeData(parkingType: ParkingType | undefined): RemoteData<PermitParkingTypeData | undefined> {
	return useRemoteData(function () {
		return parkingType == null ? Promise.resolve(undefined) : getHttpClient().permits.getParkingTypeData(parkingType);
	}, [parkingType]);
}

export function loadReservationParkingTypeData(parkingType: ParkingType): RemoteData<ReservationCategoryData>;
export function loadReservationParkingTypeData(parkingType: undefined): RemoteData<undefined>;
export function loadReservationParkingTypeData(parkingType: ParkingType | undefined): RemoteData<ReservationCategoryData | undefined>;
export function loadReservationParkingTypeData(parkingType: ParkingType | undefined): RemoteData<ReservationCategoryData | undefined> {
	return useRemoteData(function () {
		return parkingType == null ? Promise.resolve(undefined) : getHttpClient().reservations.getParkingTypeData(parkingType);
	}, [parkingType]);
}

export function isPermitParkingTypeEnabled(installation: InstallationByHostData, parkingType: ParkingType): boolean {
	return installation.parkingTypes.permits.includes(parkingType);
}

export function isReservationParkingTypeEnabled(installation: InstallationByHostData, parkingType: ParkingType): boolean {
	return installation.parkingTypes.reservations.includes(parkingType);
}
